import React, { useContext, useState } from "react";
import Error from "../../components/Error";
import Loading from "../../components/Loading";
import { AuthContext } from "../../context/auth/AuthContext";
import { Request } from "../../api/plant/Plant.api";

const initialValues = {
  name: "",
  street: "",
  city: "",
  cap: "",
  district: "",
  country: "",
};

const CreatePlantContainer = ({ children, setResult = () => {} }) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { token } = useContext(AuthContext);

  const onSubmit = (values, actions) => {
    setError(null);
    setLoading(true);
    Request.createPlant(token.access, values)
      .then((data) => onSuccess(data, actions))
      .catch((error) => onFailure(error, actions));
  };

  const onSuccess = (data, actions) => {
    actions.setSubmitting(false);
    setLoading(false);
    setResult(data.data.data);
  };

  const onFailure = (error, actions) => {
    setError(error);
    setLoading(false);
    actions.setSubmitting(false);
  };

  return (
    <>
      {error ? <Error message={error} onClose={() => setError(null)} /> : null}
      {loading ? <Loading /> : null}
      {children({ onSubmit, initialValues })}
    </>
  );
};

export default CreatePlantContainer;
